/**
 * Shared Redux selectors
 * These selectors abstract away the internal structure of the Redux state,
 * making it easier to refactor state structure without breaking components.
 */

/**
 * Select the access token from auth state
 * @param {Object} state - Redux state
 * @returns {string|null} Access token or null if not available
 */
export const selectAccessToken = (state) => {
    return state.auth?.accessToken || null;
};

/**
 * Select the refresh token from auth state
 * @param {Object} state - Redux state
 * @returns {string|null} Refresh token or null if not available
 */
export const selectRefreshToken = (state) => {
    return state.auth?.refreshToken || null;
};

/**
 * Select the user ID from auth state
 * @param {Object} state - Redux state
 * @returns {string|null} User ID or null if not available
 */
export const selectUserId = (state) => {
    return state.auth?.userId || null;
};

/**
 * Check if user is authenticated
 * @param {Object} state - Redux state
 * @returns {boolean} True if user is authenticated
 */
export const selectIsAuthenticated = (state) => {
    return !!state.auth?.accessToken;
};

